exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top[data-v-6ef7446c] {\n  padding: 1rem 1rem;\n  max-width: 1200px;\n  margin: auto;\n}\n.top .log[data-v-6ef7446c] {\n    font-weight: bold;\n    font-size: 2rem;\n    float: left;\n    width: 75%;\n}\n.top p[data-v-6ef7446c] {\n    color: #dd3c3c;\n    padding: 1rem 0;\n    padding-top: 2rem;\n}\n.top .menu[data-v-6ef7446c] {\n    float: right;\n    text-decoration: underline;\n    width: 25%;\n    font-size: 1.3rem;\n    text-align: right;\n}\n", ""]);

// exports
